import { LogglyTracker } from 'loggly-jslogger'

import { env } from '@app/env'

const loggly = env.REACT_APP_LOGGLY_KEY ? new LogglyTracker() : []

loggly.push({
  logglyKey: env.REACT_APP_LOGGLY_KEY,
  sendConsoleErrors: false,
  tag: 'lawyer_webapp,' + env.REACT_APP_LOGGLY_ENV
})

export const logger = new Proxy(console, {
  get(target, prop) {
    switch (prop) {
      case 'info':
      case 'error':
        return (message, ...rest) => {
          loggly.push({ level: prop, message })
          if (env.REACT_APP_CONSOLE_DEBUG) {
            target[prop](message, ...rest)
          }
        }

      default:
        return (...args) => {
          if (env.REACT_APP_CONSOLE_DEBUG) {
            target[prop](...args)
          }
        }
    }
  }
})
